import { render, staticRenderFns } from "./VatRateIndex.vue?vue&type=template&id=05a176f0&"
import script from "./VatRateIndex.vue?vue&type=script&lang=js&"
export * from "./VatRateIndex.vue?vue&type=script&lang=js&"
import style0 from "./VatRateIndex.vue?vue&type=style&index=0&id=05a176f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports